module.exports = __webpack_public_path__ + "media/images/talent/feature-03-e600bdfecf13703324b6f7af21efcb85.png";